<span class="px-1 fw-bold bg-secondary text-dark rounded cursor-default" title="Network Protocol">
  {{ status$ | async }}
</span>
